type TemplateId = "1" | "2" | "3" | "4" | "5"
type YPositions = number[]

// 定数
export const IMAGE_BASE_WIDTH = 640
export const CROP_PADDING = 50
export const LINE_GAP = 8
export const FONT_SIZE = 20.06
export const FONT_SIZE_PRINT = 20.06
export const FONT_SIZE_MINI = 24.25

export interface PositionPattern {
  ids: TemplateId[]
  positions: YPositions
  x: number
  width: number
  formWidth: number
  letterSpacing: number
  height: number
  gap: number
  textColor: string
}

// y座標の定義マップ: パターン名 => { ids: template_idの配列, positions: y座標の配列 }
// line2はline1の52px下に配置される
// 画像表示範囲（imageRange）は positions と height, gap から計算:
//   top: positions[0] - 100px
//   bottom: positions[最後] + height * 2 + gap + 100px
//
// positions: 各文字列グループの上端Y座標
//   計算方法: Figmaの文字列グループのY座標中央 - (height / 2)
//   例: Figma中央が299.05、height=46の場合 → 299.05 - 23 = 276
// x: 文字列グループの左端X座標（最小値）
// width: 文字列グループの幅（最大値）
// formWidth: width - 100
// height: 文字列グループの高さ（一律46px）
export const yPositionsPatterns: Record<string, PositionPattern> = {
  "1": {
    ids: ["1"],
    positions: [276, 370, 464, 558, 653],
    x: 117,
    width: 399,
    formWidth: 299,
    letterSpacing: -0.038,
    height: 46,
    gap: 8,
    textColor: "#231815",
  },
  "2": {
    ids: ["2"],
    positions: [227, 316, 404, 493, 582],
    x: 123,
    width: 399,
    formWidth: 299,
    letterSpacing: -0.038,
    height: 46,
    gap: 8,
    textColor: "#231815",
  },
  "3": {
    ids: ["3"],
    positions: [292, 399, 505, 611, 718],
    x: 90,
    width: 435,
    formWidth: 335,
    letterSpacing: -0.038,
    height: 46,
    gap: 8,
    textColor: "#231815",
  },
  "4": {
    ids: ["4"],
    positions: [148, 255, 361, 468, 574],
    x: 76,
    width: 420,
    formWidth: 320,
    letterSpacing: -0.038,
    height: 46,
    gap: 8,
    textColor: "#231815",
  },
  "5": {
    ids: ["5"],
    positions: [204, 284, 371, 465, 555],
    x: 80,
    width: 441,
    formWidth: 341,
    letterSpacing: -0.038,
    height: 46,
    gap: 8,
    textColor: "#231815",
  },
  "default": {
    ids: ["1"],
    positions: [276, 370, 464, 558, 653],
    x: 90,
    width: 399,
    formWidth: 299,
    letterSpacing: -0.038,
    height: 46,
    gap: 8,
    textColor: "#231815",
  },
}

// ミニメニュー用の位置パターン
// 画像基準幅: 640px（既存と同じ IMAGE_BASE_WIDTH を使用）
// フォントサイズ: 24.25px（FONT_SIZE_MINI）
// height: 60px
export const yPositionsPatternsMini: Record<string, PositionPattern> = {
  "1": {
    ids: ["1"],
    positions: [225, 333, 443, 551, 660],
    x: 79,
    width: 325,
    formWidth: 225,
    letterSpacing: -0.038,
    height: 60,
    gap: 8,
    textColor: "#231815",
  },
  "2": {
    ids: ["2"],
    positions: [225, 333, 443, 551, 660],
    x: 72,
    width: 325,
    formWidth: 225,
    letterSpacing: -0.038,
    height: 60,
    gap: 8,
    textColor: "#231815",
  },
  "3": {
    ids: ["3"],
    positions: [294, 402, 512, 620, 729],
    x: 85,
    width: 325,
    formWidth: 225,
    letterSpacing: -0.038,
    height: 60,
    gap: 8,
    textColor: "#231815",
  },
  "4": {
    ids: ["4"],
    positions: [167, 276, 387, 497, 607],
    x: 92,
    width: 325,
    formWidth: 225,
    letterSpacing: -0.038,
    height: 60,
    gap: 8,
    textColor: "#231815",
  },
  "5": {
    ids: ["5"],
    positions: [220, 318, 417, 515, 613],
    x: 58,
    width: 325,
    formWidth: 225,
    letterSpacing: -0.038,
    height: 60,
    gap: 8,
    textColor: "#231815",
  },
  "default": {
    ids: ["1"],
    positions: [225, 333, 443, 551, 660],
    x: 79,
    width: 325,
    formWidth: 225,
    letterSpacing: -0.038,
    height: 60,
    gap: 8,
    textColor: "#231815",
  },
}

